import { localReturnPath } from '@core/services/auth/auth-return-path';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, map } from 'rxjs';
import { selectAuth } from '@app/features/auth/auth.selectors';

function sessionGuard(administrationPage: boolean): CanActivateFn {
  return (_route, target) => {
    const router = inject(Router);
    return inject(Store)
      .select(selectAuth)
      .pipe(
        first((state) => state.init),
        map((state) => {
          if (!state.authenticated) {
            return router.createUrlTree(['/auth-code'], {
              queryParams: { returnPath: target.url },
            });
          }
          if (state.isSecurityAdministrator) {
            return (
              administrationPage ||
              router.createUrlTree(['/security-administrator'], {
                queryParams: { returnPath: target.url },
              })
            );
          }
          return (
            !administrationPage ||
            router.parseUrl(
              localReturnPath(_route.queryParamMap.get('returnPath')) ?? '/',
            )
          );
        }),
      );
  };
}

export const authGuard = sessionGuard(false);
export const securityAdministratorGuard = sessionGuard(true);
